document.addEventListener('DOMContentLoaded', () => {
  const run = document.getElementsByClassName('component pathway-sidebar');

  if (run.length > 0) {
    const toggles = document.getElementsByClassName('collapse-toggle');

    Array.from(toggles).forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        
        const parent = toggle.parentElement;

        const content = parent.querySelector('.content');

        const upArrow = parent.querySelector('.up');
        const downArrow = parent.querySelector('.down');

        const expanded = Boolean(parent.dataset.expanded);

        if (expanded) {
          content.classList.add('hidden');

          upArrow.classList.add('hidden');
          downArrow.classList.remove('hidden');

          parent.dataset.expanded = '';
        } else {
          content.classList.remove('hidden');

          upArrow.classList.remove('hidden');
          downArrow.classList.add('hidden');

          parent.dataset.expanded = true;
        }
      });
    });
  }
});
